import React, { useState } from "react";
import {
  textCapitalized,
  textCapitalizing,
} from "../../common/components/Utils";
import moment from "moment";
import rwandaLogo from "../../assets/rwanda-logo.png";
import LetterTemplateHeader from "../../documents/LetterTemplateHeader";
import LetterTemplateFooter from "../../documents/LetterTemplateFooter";

const AuthorizationLetter = (props) => {
  const {
    request,
    institutionDetail,
    coveredRelatedCostsDetails,
    copiedInstitution,
    headOfInstitution,
    draftAuthorizationLetterContent,
    draftAuthorizationLetterContentInput,
    copiedInstitutionEmailInput,
    copiedInstitutionInput,
    letterReferenceNoInput,
    letterReferenceNo,
    entitySectorId,
    planningEntityId,
    loadFooterContent,
    loadLetterContent,
  } = props;

  const [letterCustomization, setLetterCustomization] = useState(null);

  const loadHeaderContent = (data) => {
    // console.log(data);
    if (loadLetterContent) loadLetterContent(data);
    setLetterCustomization(data);
  };
  return (
    <>
      <div className="letterMainContent">
        <div className="letter">
          <LetterTemplateHeader
            disableToEdit={true}
            entitySectorId={entitySectorId}
            planningEntityId={planningEntityId}
            loadHeaderContent={(data) => loadHeaderContent(data)}
          />
          <div className="subletterhead mt-3">
            <table>
              <tr>
                <td style={{ width: "70%" }}></td>
                <td style={{ width: "30%" }}>
                  <p
                    className="date"
                    style={{
                      fontWeight: "bold",
                      float: "left",
                      textAlign: "left",
                      fontSize:
                        (letterCustomization?.styles?.fontSize || "12") +
                        "px!important",
                      fontFamily:
                        letterCustomization?.styles?.fontFamily ||
                        "Times New Roman!important",
                    }}
                  >
                    Kigali, on {moment(new Date()).format("LL")}
                    <br />N<sup>o</sup>:{" "}
                    {letterReferenceNoInput
                      ? letterReferenceNoInput
                      : letterReferenceNo
                      ? letterReferenceNo
                      : "........."}
                  </p>
                </td>
              </tr>
            </table>
            {/* <!-- Date and reference number go here --> */}
          </div>
          <div
            className={
              draftAuthorizationLetterContentInput ? "" : "auth-content"
            }
          >
            <div className="header2">
              <p
                style={{
                  fontSize:
                    (letterCustomization?.styles?.fontSize || "12") +
                    "px!important",
                  fontFamily:
                    letterCustomization?.styles?.fontFamily ||
                    "Times New Roman!important",
                  lineHeight: letterCustomization?.styles?.lineHeight,

                  lineSpacing: `${
                    letterCustomization?.styles?.lineSpacing || 0
                  }px!important`,
                }}
              >
                <span>Right Hon. Prime Minister</span> <br />
                <strong
                  style={{
                    fontSize:
                      (letterCustomization?.styles?.fontSize || "12") +
                      "px!important",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman!important",
                    textDecoration: "underline",
                  }}
                >
                  KIGALI
                </strong>
              </p>
              <p
                style={{
                  paddingTop: "10px",
                  fontSize:
                    (letterCustomization?.styles?.fontSize || "12") +
                    "px!important",
                  fontFamily:
                    letterCustomization?.styles?.fontFamily ||
                    "Times New Roman!important",
                  lineHeight: letterCustomization?.styles?.lineHeight,
                  lineSpacing: `${
                    letterCustomization?.styles?.lineSpacing || 0
                  }px!important`,
                }}
              >
                <span>Right Hon. Prime Minister,</span>
              </p>
              <p
                style={{
                  paddingTop: "10px",
                  fontSize:
                    (letterCustomization?.styles?.fontSize || "12") +
                    "px!important",
                  fontFamily:
                    letterCustomization?.styles?.fontFamily ||
                    "Times New Roman!important",
                  lineHeight: letterCustomization?.styles?.lineHeight,

                  lineSpacing: `${
                    letterCustomization?.styles?.lineSpacing || 0
                  }px!important`,
                }}
              >
                <strong className="tn-subject">Subject:</strong>{" "}
                <strong>Authorization for training</strong>
              </p>
            </div>

            <div
              style={{ marginBottom: "30px" }}
              className={draftAuthorizationLetterContentInput ? "" : "content2"}
            >
              {draftAuthorizationLetterContentInput ? (
                draftAuthorizationLetterContentInput
              ) : draftAuthorizationLetterContent ? (
                <>
                  <div
                    style={{
                      fontSize:
                        (letterCustomization?.styles?.fontSize || "12") +
                        "px!important",
                      fontFamily:
                        letterCustomization?.styles?.fontFamily ||
                        "Times New Roman!important",
                      lineHeight: letterCustomization?.styles?.lineHeight,

                      lineSpacing: `${
                        letterCustomization?.styles?.lineSpacing || 0
                      }px!important`,

                      textAlign: letterCustomization?.styles?.textAlign || "",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: draftAuthorizationLetterContent,
                    }}
                  ></div>
                </>
              ) : (
                <>
                  <p>
                    Reference is made to letter N<sup>o</sup>{" "}
                    {request.referenceNo} of{" "}
                    {moment(request.ministryApprovedDate).format("ll")} from the
                    Hon.{" "}
                    {request.ministryEntityName.replace("Ministry", "Minister")}{" "}
                    requesting authorization for training in favour of{" "}
                    {request.lastName.toUpperCase()}{" "}
                    {textCapitalizing(request.firstName)};
                  </p>

                  <p>
                    I would like to inform Your Excellency that{" "}
                    {request.employeeTitle}. {request.lastName.toUpperCase()}{" "}
                    {textCapitalizing(request.firstName)},{" "}
                    {request.positionName},{request.unitName} in the{" "}
                    {request.entityName} is authorised to attend a training on{" "}
                    {request.trainingTitle}, {request.countryForTraining} from{" "}
                    {moment(request.trainingDurationFrom).format("ll")} to{" "}
                    {moment(request.trainingDurationTo).format("ll")}.{" "}
                    {!request.isTrainingInsideCountry && (
                      <>
                        The date of departure is{" "}
                        {moment(request.departureDate).format("ll")} and the
                        returning date is{" "}
                        {moment(request.returningDate).format("ll")}.
                      </>
                    )}
                    {coveredRelatedCostsDetails
                      ? coveredRelatedCostsDetails
                      : request.coveredRelatedCostsDetails}
                    .
                  </p>

                  <p>Attached are the documents related to the training.</p>
                  <p>
                    Please accept, Right Hon. Prime Minister, the assurances of
                    my usual highest consideration and esteem.
                  </p>
                </>
              )}
            </div>

            <div
              className="signature"
              style={{
                fontSize:
                  (letterCustomization?.styles?.fontSize || "12") +
                  "px!important",
                fontFamily:
                  letterCustomization?.styles?.fontFamily ||
                  "Times New Roman!important",
                lineHeight: letterCustomization?.styles?.lineHeight,

                lineSpacing: `${
                  letterCustomization?.styles?.lineSpacing || 0
                }px!important`,
              }}
            >
              {institutionDetail}

              {!copiedInstitutionInput && (
                <p className="mt-4">
                  <strong style={{ textDecoration: "underline" }}>Cc:</strong>
                </p>
              )}

              {copiedInstitutionInput ? (
                copiedInstitutionInput
              ) : (
                <p
                  style={{
                    lineHeight: "21.5px",
                    marginLeft: "-20px",
                    fontSize:
                      (letterCustomization?.styles?.fontSize || "12") +
                      "px!important",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman!important",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px!important`,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: copiedInstitution
                      ? copiedInstitution
                      : request.copiedInstitution,
                  }}
                ></p>
              )}
              {!copiedInstitutionEmailInput && (
                <strong
                  style={{
                    fontSize:
                      (letterCustomization?.styles?.fontSize || "12") +
                      "px!important",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman!important",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px!important`,
                    textDecoration: "underline",
                    marginTop: "-15px",
                  }}
                >
                  KIGALI
                </strong>
              )}
              {copiedInstitutionEmailInput && (
                <>{copiedInstitutionEmailInput}</>
              )}
            </div>
          </div>
          <div className="mt-5 pt-5">
            <LetterTemplateFooter
              disableToEdit={true}
              loadFooterContent={loadFooterContent}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthorizationLetter;
